<template>
  <div class="comp_member_box" :class="isNewUserStatus ? 'style_1' : 'style_2'">
    <slot></slot>
  </div>
</template>

<script>
import mixin from '@/page/member/mixins.js'

export default {
  name: 'MemberBox',
  mixins: [mixin],
}
</script>

<style lang="scss" scoped>
.comp_member_box {
  &.style_1 {
    background-color: #fff;
    border-radius: 64px 64px 8px 8px;
  }
  &.style_2 {
  }
}
</style>
